import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Empty, Result, Button } from 'antd';

import Loading from '../../components/Loading';
import { usePermission } from '../../functions/permissionValidator';
import {
  loadEngines,
  selectListedEngines,
  selectEnginesLoading,
  selectEnginesFailedToLoad,
} from './engineSlice';

import Engine from './Engine';

function EnginesContainer() {
  const dispatch = useDispatch();
  const engines = useSelector(selectListedEngines);
  const loading = useSelector(selectEnginesLoading);
  const failedToLoad = useSelector(selectEnginesFailedToLoad);
  const { isGlobalAdmin } = usePermission();
  const canManage = isGlobalAdmin();

  useEffect(() => {
    dispatch(loadEngines());
  }, [dispatch]);

  if (loading && !engines.length) {
    return <Loading text="Loading apps..." />;
  }

  if (failedToLoad && !engines.length) {
    return (
      <Result
        status="error"
        title="Could not load apps"
        extra={
          <Button type="primary" onClick={() => dispatch(loadEngines())}>
            Retry
          </Button>
        }
      />
    );
  }

  if (!engines.length) {
    return (
      <Empty
        style={{ padding: 24 }}
        description="No apps are installed on this Nominode."
      />
    );
  }

  return (
    <div>
      {engines.map((engine) => (
        <Engine key={engine.uuid} engine={engine} canManage={canManage} />
      ))}
    </div>
  );
}

export default EnginesContainer;
